export const documentsTopLevelFilterKeys = ['all', 'contracts', 'orderForms', 'msa'] as const
export type DocumentsTopLevelFilterKey = (typeof documentsTopLevelFilterKeys)[number]
